import React from "react";

export const AplicativosHeaderText = () => {
  return (
    <>
      <p>Paciente ProntLife</p>
      <h1 className="main-title text-primary font-weight-bold">
        Você no Centro do Cuidado
      </h1>
      <h2 className="main-subtitle">
        Tenha seu prontuário médico sempre com você! Acesse seu histórico de
        saúde, medicamentos e carteirinha do plano sempre que precisar.
      </h2>
    </>
  );
};
